export default class {
  constructor() {
    this.tab = '.js-tab';
    this.triggerItem = '.js-tab__trigger-item';
    this.init();
  }

  init() {
    const triggerItem = document.querySelectorAll(this.triggerItem);
    if (this.tab) {
      for (let i = 0; i < triggerItem.length; i++) {
          triggerItem[i].addEventListener('click', toggle);
      }

      function toggle() {
        const tabWrap = this.closest('.js-tab');
        const triggers = tabWrap.querySelectorAll('.js-tab__trigger-item');
        const contents = tabWrap.querySelectorAll('.js-tab__contents-item');
        for (let i = 0; i < triggers.length; i++) {
          triggers[i].classList.remove('is-active');
        }
        for (let i = 0; i < contents.length; i++) {
          contents[i].classList.remove('is-show');
          contents[i].classList.remove('is-active');
        }
        this.classList.add('is-active');
        const aryTabs = Array.from(triggers);
        const index = aryTabs.indexOf(this);
        contents[index].classList.add('is-show');
        contents[index].classList.add('is-active');
      }

    }

    const tab02 = document.querySelector(".js-tab");

    if (tab02) {
      const tabTop = document.querySelectorAll(".js-tab-top__trigger-item");
      const tabBottom = document.querySelectorAll(".js-tab-bottom__trigger-item");
      const tabContent = document.querySelectorAll(".js-tab__contents-item");
      //上のタブをクリックしたとき
      tabTop.forEach((element, index) => {
        element.addEventListener("click", () => {
          tabSwitch(index);
        });
      });
      //下のタブをクリックしたとき
      tabBottom.forEach((element,index) => {
        element.addEventListener("click", () => {
          tabSwitch(index);
          const element = document.getElementById('tabTop');
          element.scrollIntoView({
            behavior: 'smooth'
          });
        });
      });
      //クリックした時の処理（共通）
      function tabSwitch(num) {
        for (let ii = 0; ii < tabTop.length; ii++) {
          tabTop[ii].classList.remove("is-active");
          tabBottom[ii].classList.remove("is-active");
          tabContent[ii].classList.remove("is-show");
        }
        tabTop[num].classList.add("is-active");
        tabBottom[num].classList.add("is-active");
        tabContent[num].classList.add("is-show");
      }
    }
  }
}